import { Backdrop, Box, Button, CircularProgress, Container, Typography } from "@mui/material"
import { useContext, useEffect, useState } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { getOAuthAuthorizeUrl, getToken, verifyAuth } from "../../controllers/accounts/auth";
import { UserContext } from "../../context/UserContext";
import { useNavigate } from "react-router-dom";
import { getSingleAccount } from "../../controllers/accounts/accounts";

export const Login = () => {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString)
    const code = urlParams.get('code')
    const [open, setOpen] = useState(false);
    const { setUserDetails } = useContext(UserContext)
    const [tempTokens, setTemTokens] = useState({})
    const authorizeUrl = getOAuthAuthorizeUrl()
    const queryClient = useQueryClient()

    let navigate = useNavigate()

    const handleClose = () => {
      setOpen(false);
    };

    const validateCode = async (code) => {
      setOpen(true) // Show loading spinner
      localStorage.removeItem('user')
      // Logging in mid-session (switching accounts) doesn't reload the page, so the
      // previous account's cached profile/photos would otherwise stick around.
      queryClient.clear()
      let stored_token = await getToken(code)
      setTemTokens(stored_token)
    }

    useEffect(() => {
      if(code){
        validateCode(code)
      }
    }, [code])

    useEffect(() => {
      let saveToken = tempTokens?.access_token // ?? "yV3oz077h9pMUhBMlavnxWgEnGyqXuDLGOsY6T3xD70"
      
      if(saveToken){
        localStorage.setItem('token', saveToken)
        
        const local_account = async () => {
          let verified_user = await verifyAuth(saveToken)
          if (verified_user?.id) {
            let user = await getSingleAccount(verified_user.id, saveToken)
            const hydratedUser = { ...verified_user, ...user?.account, ...user?.mastodon }
            localStorage.setItem('user', JSON.stringify(hydratedUser))
            setUserDetails({ token: saveToken, ...hydratedUser })
            // Redirect to homepage after successful authentication
            navigate('/')
          } else {
            // If verification fails, clear invalid token and show login screen
            localStorage.removeItem('user')
            localStorage.removeItem('token')
            setOpen(false)
          }
        }

        local_account()
      }
    }, [tempTokens, navigate])
    return (
        <>
        <Backdrop
            sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={open}
            onClick={handleClose}
        >
            <CircularProgress color="inherit" />
        </Backdrop>
        <Container
          maxWidth={false}
          disableGutters
          sx={{
            width: '100%',
            zIndex: 1,
            px: 1.5,
            pb: 1,
          }}
        >
          <Box
            sx={{
              maxWidth: 560,
              mx: 'auto',
              color: '#fff',
              textAlign: 'center',
              background: 'linear-gradient(110deg, #23232b 0%, #303247 55%, #3a3e63 100%)',
              borderTopLeftRadius: 16,
              borderTopRightRadius: 16,
              borderBottomLeftRadius: 14,
              borderBottomRightRadius: 14,
              border: '1px solid rgba(255,255,255,0.12)',
              boxShadow: '0 -2px 16px rgba(0,0,0,0.22)',
              backdropFilter: 'blur(8px)',
              px: 2,
              py: 1.25,
            }}
          >
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 0.5 }}>
              <Typography sx={{ fontSize: 18, lineHeight: 1 }}>🏳️‍🌈</Typography>
              <Typography sx={{ fontWeight: 800, fontSize: 14, letterSpacing: '-0.2px', color: '#fff' }}>
                Welcome to MakeGayFriends
              </Typography>
              <Typography sx={{ fontSize: 12, color: 'rgba(255,255,255,0.82)', mb: 0.75 }}>
                Sign in to continue or create your account in seconds.
              </Typography>

              <Box sx={{ display: 'flex', gap: 1, width: '100%', justifyContent: 'center' }}>
                  <Button
                    variant="contained"
                    fullWidth
                    onClick={() => window.location.assign(authorizeUrl)}
                    sx={{
                      background: '#fff',
                      color: '#23232b',
                      fontWeight: 800,
                      borderRadius: 2,
                      minHeight: 40,
                      textTransform: 'none',
                      '&:hover': {
                        background: '#f3f4f8',
                      },
                    }}
                  >
                    Login
                  </Button>
                <Button
                  onClick={() => navigate("/register")}
                  variant="outlined"
                  fullWidth
                  sx={{
                    borderColor: 'rgba(255,255,255,0.6)',
                    color: '#fff',
                    fontWeight: 800,
                    borderRadius: 2,
                    minHeight: 40,
                    textTransform: 'none',
                    background: 'rgba(255,255,255,0.08)',
                    '&:hover': {
                      borderColor: '#fff',
                      background: 'rgba(255,255,255,0.15)',
                    },
                  }}
                >
                  Register
                </Button>
              </Box>
            </Box>
          </Box>
        </Container>
        </>
    )
}